<template>
  <div class="container">
    <!--Section: Content-->
    <section class="formation">
      <!-- Section heading -->
      <h2 class="text-center font-weight-bold">Formations VTC</h2>
      <!-- Section description -->
      <div class="mx-auto w-responsive">
        <div class="container">
          <!--Section: Content-->
          <section class="text-center">
            <!-- Section heading -->
            <p
              class="text-center argument font-weight-bold dark-grey-text pb-2 my-4"
            >
              <strong>Prix formations vtc</strong>
            </p>
            <!-- Section description -->
            <p class="text-center w-responsive mx-auto mb-5">
              Découvrez nos <strong>formations VTC</strong>, conçues pour vous
              former aux exigences spécifiques du métier de
              <strong>chauffeur VTC</strong>.
            </p>

            <ServicePricingCarousel
              eyebrow="Formation VTC"
              :offers="carouselOffers"
            />
          </section>
          <!--Section: Content-->
        </div>
      </div>
      <div class="hr-d"></div>
      <CallToContact
        title="Contactez nous"
        subTitle="L'equipe pédagogique de l'institut taxi s'occupe de vos démarches administratives."
      />
      <!-- Grid row -->
    </section>
    <!--Section: Content-->
  </div>
  <section class="container-fluid double-block">
    <div class="double-block__title">
      <h2><span class="brand-pseudo">ITTI</span><br />Ecole VTC</h2>
    </div>
    <div class="dark-grey-text double-block__articles">
      <ServiceFeatureBlock
        title="Préparez une carrière professionnelle"
        tone="secondary"
        :copy-html="featureCopy.intro"
      >
        <template #media>
          <img
            src="@/assets/pictures/vtc-course.webp"
            alt="a-car-in-paris"
            class="img-fluid"
            loading="lazy"
          />
        </template>
      </ServiceFeatureBlock>
      <div class="hr-d"></div>
      <ServiceFeatureBlock
        title="Gagnez en souplesse"
        tone="primary"
        reverse
        :copy-html="featureCopy.evening"
      >
        <template #media>
          <img
            src="@/assets/pictures/sunny.webp"
            alt="rising-sun"
            class="img-fluid"
            loading="lazy"
          />
        </template>
      </ServiceFeatureBlock>
    </div>
  </section>
  <HomeEnd section="VTC" />
</template>

<script>
import CallToContact from "@/components/plugins/CallToContact.vue";
import HomeEnd from "../home/HomeEnd.vue";
import ServiceFeatureBlock from "./ServiceFeatureBlock.vue";
import ServicePricingCarousel from "./ServicePricingCarousel.vue";

const featureCopy = {
  intro:
    "Notre <strong>formation VTC</strong> vous prépare à l'obtention de la <strong>carte professionnelle</strong> avec une approche complète et concrète. Vous abordez la réglementation, la conduite, la gestion des itinéraires, la sécurité et la qualité de service attendue par la clientèle. L'accompagnement pédagogique vous guide vers les examens avec méthode, avec des sessions <strong>éligibles au CPF</strong>. L'objectif est de vous rendre opérationnel plus vite, avec une préparation lisible et utile sur le terrain. Vous avancez avec un cadre clair pour comprendre les attentes du métier, la relation client premium et les réflexes à adopter dès les premières courses.",
  evening:
    "Nos <strong>cours accélérés</strong> et du soir permettent de préparer la <strong>carte VTC</strong> plus vite, tout en gardant un rythme compatible avec une activité en journée. Vous avancez sur les modules essentiels avec un encadrement clair, des horaires plus souples et des solutions de financement adaptées. Le <strong>CPF</strong> et le paiement en trois fois facilitent aussi l'accès à la formation. C'est une formule utile pour avancer sans désorganiser votre planning. Elle convient particulièrement aux candidats qui veulent rester actifs tout en conservant une préparation sérieuse aux épreuves théoriques, à la conduite et à la qualité de service attendue en activité VTC.",
};

const featuredOffers = [
  {
    id: "vtc-initiale-day",
    title: "Initiale",
    badge: "Journée",
    price: "1350",
    fee: "+237€ frais examen CMA",
    route: "/formation-vtc-initiale",
    meta: [
      { label: "Durée", value: "3 semaines" },
      { label: "Rythme", value: "Lundi au vendredi" },
      { label: "Horaires", value: "9h30 / 16h30" },
    ],
    highlights: [
      "Éligible CPF",
      "Paiement en 3x sans frais",
      "3 séances de conduite",
      "Véhicule mis à disposition le jour de l'examen",
    ],
  },
  {
    id: "vtc-initiale-evening",
    title: "Initiale",
    badge: "Soir",
    price: "1350",
    fee: "+237€ frais examen CMA",
    route: "/formation-vtc-initiale",
    meta: [
      { label: "Durée", value: "2 semaines" },
      { label: "Rythme", value: "Lundi au vendredi" },
      { label: "Horaires", value: "18h / 22h" },
    ],
    highlights: [
      "Examen blanc inclus",
      "Éligible CPF",
      "Paiement en 3x sans frais",
      "3 séances de conduite",
      "Véhicule mis à disposition le jour de l'examen",
    ],
  },
  {
    id: "vtc-initiale-weekend",
    title: "Initiale",
    badge: "Week-end",
    price: "1350",
    fee: "+237€ frais examen CMA",
    route: "/formation-vtc-initiale",
    meta: [
      { label: "Durée", value: "4 week-ends" },
      { label: "Rythme", value: "Samedi et dimanche" },
      { label: "Horaires", value: "9h30 / 16h30" },
    ],
    highlights: [
      "Examen blanc inclus",
      "Éligible CPF",
      "Paiement en 3x sans frais",
      "3 séances de conduite",
      "Véhicule mis à disposition le jour de l'examen",
    ],
  },
  {
    id: "vtc-elearning",
    title: "E-learning",
    badge: "En ligne",
    price: "549",
    fee: "Frais d'examen inclus",
    route: "/formation-vtc-en-ligne",
    meta: [
      { label: "Durée", value: "1 mois" },
      { label: "Support", value: "Application ludo-pédagogique" },
      { label: "Questions", value: "Entre 1 000 et 1 500" },
    ],
    highlights: [
      "4 fois 137,25€ sans frais",
      "QCM, jeux, duels, etc.",
      "Théorie et pratique avec véhicule",
      "Examen blanc inclus",
    ],
  },
];

const secondaryOffers = [
  {
    id: "vtc-continue",
    title: "Continue",
    badge: "14h",
    price: "170",
    route: "/formation-vtc-continue",
    meta: [
      { label: "Volume", value: "14h / 2 jours" },
      { label: "Planning", value: "Disponibilité à convenir" },
    ],
    note: {
      title: "A savoir",
      text: "Cette formation continue est obligatoire pour les chauffeurs VTC déjà titulaires de la carte professionnelle. Elle se suit tous les 5 ans pour actualiser réglementation, sécurité routière et pratique métier.",
    },
    highlights: [],
  },
  {
    id: "vtc-pratique-seule",
    title: "Pratique seule",
    badge: "Conduite",
    price: "390",
    route: "/formation-vtc-pratique-seule",
    meta: [
      { label: "Accompagnement", value: "3 séances de conduite" },
      {
        label: "Examen",
        value: "Véhicule mis à disposition le jour de l'examen",
      },
    ],
    note: {
      title: "Pour qui ?",
      text: "Cette formule vise l'épreuve pratique T3P uniquement. Elle permet de travailler la conduite en circulation, les manoeuvres utiles et les conditions réelles de l'examen avec véhicule adapté.",
    },
    highlights: [],
  },
  {
    id: "passerelle-taxi-vtc",
    title: "Passerelle",
    badge: "Taxi > VTC",
    price: "600",
    fee: "+162€ frais examen CMA",
    route: "/formation-mobilite-passerelle-taxi-vers-vtc",
    meta: [
      { label: "Volume", value: "5 jours" },
      { label: "Planning", value: "Disponibilités à convenir" },
    ],
    note: {
      title: "Transition",
      text: "Cette passerelle permet de basculer vers l'activité VTC sans repartir sur une formation complète. Vous travaillez les règles, la relation client et les spécificités du métier.",
    },
    highlights: ["Véhicule mis à disposition le jour de l'examen"],
  },
  {
    id: "passerelle-vtc-taxi",
    title: "Passerelle",
    badge: "VTC > Taxi",
    price: "600",
    fee: "+162€ frais examen CMA",
    route: "/formation-mobilite-passerelle-vtc-vers-taxi",
    meta: [
      { label: "Volume", value: "5 jours" },
      { label: "Planning", value: "Disponibilités à convenir" },
    ],
    note: {
      title: "Transition",
      text: "Cette formule prépare la conversion vers l'activité taxi avec un focus sur la réglementation, la gestion de l'activité et les spécificités du terrain.",
    },
    highlights: ["Véhicule mis à disposition le jour de l'examen"],
  },
];

const carouselOffers = [
  ...featuredOffers.map((offer) => ({
    ...offer,
    variant: "primary",
  })),
  ...secondaryOffers.map((offer) => ({
    ...offer,
    variant: "light",
  })),
];
export default {
  name: "ServicesVtc",
  components: {
    CallToContact,
    HomeEnd,
    ServiceFeatureBlock,
    ServicePricingCarousel,
  },
  data() {
    return {
      carouselOffers,
      featureCopy,
    };
  },
  mounted() {
    import("@/assets/globalJs/global.js").then((module) => {
      const { observeElements } = module;
      observeElements(".slide-right", ".slide-left", ".fall");
    });
  },
};
</script>

<style lang="scss" scoped>
.formation {
  & h2 {
    text-align: center;
    background-color: $color-primary;
    color: $color-secondary;
    padding: 10px;
  }
  & .argument {
    font-family: "Spartan", "Arial Black", Arial, sans-serif;
    font-weight: 700;
    font-size: 1.3em;
  }
  .price-card {
    & .card {
      color: $color-text-light;
      background: #000000; /* fallback for old browsers */
      background: -webkit-linear-gradient(
        to bottom,
        #434343,
        #000000
      ); /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(
        to bottom,
        #434343,
        #000000
      ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

      display: flex;
      flex-direction: column;
      height: 100%;

      & h3 {
        background-color: $color-primary;
        font-family: "quantum";
        color: $color-text-light;
        padding: 10px;
      }
      & .price {
        text-align: center;
        font-size: 2em;
        margin-bottom: 0px;
        & span {
          color: $color-secondary;
        }
      }
      & .priceBis {
        text-align: center;
        font-size: small;
        margin-bottom: 20px;
      }
      & .card-body {
        padding: 0px;
        flex-grow: 1;
        & ul {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          list-style-type: none;
          padding: 0px;
          & li,
          p {
            text-align: center;
          }
        }
      }
      & .card-footer {
        background-color: $color-secondary;
        padding: 0px;
        margin-top: auto;
        position: absolute;
        bottom: 0px;
        width: 100%;
      }
    }
    & .big {
      min-height: 675px;
    }
    & .little {
      min-height: 345px;
    }
  }
}
.double-block {
  padding: clamp(74px, 9vw, 108px) 20px clamp(92px, 11vw, 126px);

  @media screen and (min-width: 768px) {
    padding-inline: 28px;
  }

  @media screen and (min-width: 992px) {
    padding: clamp(88px, 9vw, 116px) clamp(28px, 4vw, 56px)
      clamp(110px, 10vw, 138px);
  }

  &__title {
    width: min(100%, 1040px);
    padding: 0;
    text-align: center;
    margin: 0 auto 44px;

    & h2 {
      margin: 0;
      font-family: "Spartan", "Arial Black", Arial, sans-serif;
      font-weight: 700;
      color: $color-primary;
      font-size: clamp(1.56rem, 1.18rem + 0.98vw, 2.3rem);
      line-height: 1.02;
      letter-spacing: 0.03em;
      text-shadow: 0 1px 0 rgba(255, 255, 255, 0.88),
        0 14px 28px rgba(0, 42, 84, 0.08);
    }

    @media screen and (min-width: 992px) {
      margin-bottom: 56px;
    }
  }

  &__articles {
    width: min(100%, 1180px);
    margin: 0 auto;

    > .hr-d {
      width: 94px;
      height: 4px;
      margin: 34px auto 38px;
      border-radius: 999px;
      background: $color-secondary;
      opacity: 1;
      box-shadow: 0 10px 22px rgba(254, 185, 20, 0.18);

      @media screen and (min-width: 992px) {
        margin: 40px auto 44px;
      }
    }
  }
}

.brand-pseudo {
  display: inline-block;
  margin-bottom: 10px;
  font-family: "adam";
  font-size: 0.72rem;
  letter-spacing: 0.34em;
  text-transform: uppercase;
  color: $color-secondary;
  text-shadow: none;
}
.exe {
  color: $color-secondary;
  font-size: 1em;
}
.slide-right.active {
  @include slide-right(1.2s);
}
.slide-left.active {
  @include slide-left(1.2s);
}
.fall.active {
  @include fall-down(1s);
}
</style>
